import { useEffect, useRef } from 'react';
import { logProductionModalOpened } from '../project/utils/productionAudit';

/** Log once each time a production modal opens (any entry path). */
export function useProductionModalAudit(
  isOpen: boolean,
  modalName: string,
  projectId?: number | string | null,
  projectName?: string | null,
  source = 'production'
): void {
  const loggedRef = useRef(false);

  useEffect(() => {
    if (isOpen && !loggedRef.current) {
      loggedRef.current = true;
      logProductionModalOpened({ modal: modalName, projectId, projectName, source });
    }
    if (!isOpen) {
      loggedRef.current = false;
    }
  }, [isOpen, modalName, projectId, projectName, source]);
}
